// utils/customTheme.ts

import { ThemeConfig, theme } from "antd";

export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
};
